<template>
  <v-footer app elevation="1">
    <v-spacer />
    <small
      >Made with <v-icon color="red" size="x-small">mdi-heart</v-icon> by
      <a class="link" href="https://xstudios.com/" target="_blank"
        >X Studios&trade;</a
      >
      in Winter Park, FL.
      <slot name="links" />
    </small>
  </v-footer>
</template>

<style scoped>
  .link {
    text-decoration: none;
    color: inherit;
  }
  .link:hover {
    color: inherit;
  }
</style>
